// Entry point for the build script in your package.json
import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"

// PureChat (3rd-party chat widget) self-injects into <body> and runs polling
// timers on window. Turbo Drive swaps <body> on every navigation, orphaning the
// widget while its timers keep firing (NS_ERROR_NOT_INITIALIZED, hung visits).
//
// We can't disable Drive globally: the app relies on Turbo Drive to process
// <turbo-stream> responses from regular form submissions (e.g. the wizard's
// "Add This"), and those break if Drive is off. Instead, only force a full page
// load when navigating AWAY from a page where PureChat is actually loaded, so the
// widget is torn down cleanly. This leaves Drive, Turbo Frames, and Stream form
// responses fully working everywhere PureChat isn't present (admin, store, and —
// since PureChat needs a store purechat_key — the entire test suite).
//
// window.__purechatLoaded is set by app/views/layouts/_purechat.html.erb.
//
// Link clicks / Turbo.visit fire turbo:before-visit: cancel the visit before it
// fetches and do a full load to the destination instead.
document.addEventListener("turbo:before-visit", (event) => {
  if (window.__purechatLoaded) {
    event.preventDefault()
    window.location.href = event.detail.url
  }
})

// Browser back/forward (restoration) visits do NOT fire turbo:before-visit, so the
// above would miss them and Turbo would body-swap the PureChat page in place. Catch
// the swap at render time instead; on a restoration render window.location is already
// the destination, so a reload lands there with the widget fully torn down. Advance
// visits are already cancelled above, so in practice this only runs for restoration.
// turbo:before-render is Drive-page-only — Turbo Frames and Stream renders use their
// own events (turbo:before-frame-render / turbo:before-stream-render) and are unaffected.
document.addEventListener("turbo:before-render", (event) => {
  if (window.__purechatLoaded) {
    event.preventDefault()
    window.location.reload()
  }
})

Rails.start()
ActiveStorage.start()

// Font Awesome icons
import "@fortawesome/fontawesome-free/js/all"

import LocalTime from 'local-time'
LocalTime.start()
import "trix"
import "@rails/actiontext"

import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(ChartDataLabels)
window.Chart = Chart
